export enum TimeUnit {
    // none = 0,
    // millisecond = 1,
    // second = 2,
    minute = 3,
    hour = 4,
    day = 5,
    month = 6,
    // year = 7
}
